const regExp = /([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/g

const filterRemoveEmail = (text: string) => text.replace(regExp, '[...]')

export default filterRemoveEmail
